import React from 'react';
import Counsellor from './Counsellor.js';
import { Link } from 'react-router-dom'
import DevOps from "../Image/DevOps.webp"
import Stock_Market from '../Image/Stock_Market.webp'
import Video_Editing from "../Image/Video_Editing.webp"
import uiux from "../Image/uiux.webp"
import Legal_Drafting from "../Image/Legal_Drafting.webp"
import Graphic_Design from "../Image/Graphic_Design.webp"

function ComingProgram() {
  return (
    <>
    <div>
      <div>
        {/* -----------------------Mobile View------------------------ */}
        <div className="Combo_background_image d-sm-block d-md-none mt-5">
          <div className="container-fluid Combo_background_color pt-5">
            <div className="text-center Combo_Main_text py-5">
              <h1 className="display-2 text-white">Coming Soon Program</h1>
            </div>
          </div>
        </div>

        {/* -------------------Desktop View------------------------- */}
        <div className="Combo_background_image d-none d-md-block mt-5">
          <div className="container-fluid  Combo_background_color py-5">
            <div className="text-center py-5 Combo_Main_text mt-5">
              <h1 className="display-3 py-5 mt-5 text-white">Coming Soon Program</h1>
            </div>
          </div>
        </div>
      </div>
      <div>
        <ProgramCard />
        <Counsellor />
      </div>
    </div>
    </>
  );
}

function ProgramCard() {
  const courses = [
    { name: 'DevOps / Course', className: 'DevOps_card_img',link: '/DevOps-Course', },
    { name: 'Stock Market Course', className: 'Stock_Market_img',link: '/Stock-Market-Course', },
    { name: 'Video Editing Course', className: 'Video_Editing_img',link: '/Video-Editing-Course', },
    { name: 'UI/UX Design Course', className: 'UIUX_Design_img',link: '/UI-UX-Design-Course', },
    { name: 'Graphic Design Course', className: 'Graphic_Design_img',link: '/Graphic-Design-Course', },
    { name: 'Legal Drafting Course', className: 'Legal_Drafting_img',link: '/Legal-Drafting-Course', },
  ];

  return (
    <>
    <style>{`
     .DevOps_card_img{
        background: url(${DevOps});
        background-color: black;
        background-size: cover;
      }
      .Stock_Market_img{
        background: url(${Stock_Market});
        background-color: black;
        background-size: cover;
      }
      .Video_Editing_img{
        background: url(${Video_Editing});
        background-color: black;
        background-size: cover;
      }
      .UIUX_Design_img{
        background: url(${uiux});
        background-color: black;
        background-size: cover;
      }
      .Graphic_Design_img{
        background: url(${Graphic_Design});
        background-color: black;
        background-size: cover;
      }
      .Legal_Drafting_img{
        background: url(${Legal_Drafting});
        background-color: black;
        background-size: cover;
      }
     `}</style>
    <div>
      <div className="container d-sm-block d-md-none">
        <div className="text-center mt-3 mobile_About_Discraption_text">
          <h1 className="display-4 text-center">
            Our Company New Up Coming Program
          </h1>
          <p>
            InternsElite is an organisation with the mission of preparing
            students for professional success in both technical and
            nontechnical fields through meaningful internship experiences. Here
            at InternsElite, we guide students in the right direction by giving
            them the knowledge, tools, and resources they need to make an
            informed decision about their future careers. Using artificial
            intelligence (AI) software and other cutting-edge technology, we
            teach our pupils and help them improve their skills in general.
          </p>
        </div>
      </div>

      <div className="container d-none d-md-block pt-4">
        <div className="row">
          <div className="container px-5">
            <div className="text-center About_Discraption_text">
              <h1 className="display-6">
                Our Company New Up Coming Program
              </h1>
              <p>
                InternsElite is an organisation with the mission of preparing
                students for professional success in both technical and
                nontechnical fields through meaningful internship experiences.
                Here at InternsElite, we guide students in the right direction
                by giving them the knowledge, tools, and resources they need to
                make an informed decision about their future careers. Using
                artificial intelligence (AI) software and other cutting-edge
                technology, we teach our pupils and help them improve their
                skills in general.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container my-5">
        <div className="row">
        {courses.map((course, index) => (
            <div key={index} className="col-md-3 mt-4">
            <Link className='Program_card_link' to={course.link}>
              <div className={`coming_card ${course.className} shadow`}>
                <div className="coming_card_overlay">
                  <div className="coming_card_items"></div>
                  <div className="coming_card_items coming_card_head">
                    <p className="pt-2">{course.name}</p>
                  </div>
                </div>
              </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
    </>
  );
}

export default ComingProgram;
